import { map } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { SurchargeTypeMapper } from "./surcharge-type.mapper";

import { SurchargeType } from "./surcharge-type.model";
import { environment } from "environments/environment";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";
import { Rate } from "../rate/rate-type";
import { SurchargeTypeUpdater } from "./surcharge-type-updater/surcharge-type-updater.model";
import { PaginationList } from "../shared/grid/pagination-list.model";
import { PaginatedResponse } from "../shared/http/paginated-response.model";
import { SurchargeTypeRate } from "./surcharge-type-rates/surcharge-type-rate.model";
import { SurchargeTypeRateMapper } from "./surcharge-type-rates/surcharge-type-rate.mapper";

@Injectable()
export class SurchargeTypeRepository extends CrudAbstractRepository {
  getMapper(): any {
    return SurchargeTypeMapper.map;
  }

  getEndpoint(): string {
    return "surchargeType";
  }

  public list(): Observable<SurchargeType[]> {
    return this.http
      .get<object[]>(`${environment.apiUrl}/surchargeType/list`)
      .pipe(map((response) => response.map(this.getMapper())));
  }

  public batchUpdate(
    surchargeType: SurchargeType,
    model: SurchargeTypeUpdater,
  ): Observable<object> {
    return this.http.patch(
      `${environment.apiUrl}/${this.getEndpoint()}/${surchargeType.getId()}/batchUpdate`,
      model.getRequestParams(),
    );
  }

  public listByRate(
    rate: Rate,
    quoteId: number = null,
  ): Observable<SurchargeType[]> {
    const params = quoteId
      ? new HttpParams().set("quote", quoteId)
      : new HttpParams();

    return this.http
      .get<object[]>(
        `${environment.apiUrl}/rate/${rate.getId()}/surchargeType`,
        { params: params },
      )
      .pipe(map((response) => response.map(this.getMapper())));
  }

  public listRates(
    surchargeTypeId: number,
    params: HttpParams = new HttpParams(),
  ): Observable<PaginationList<SurchargeTypeRate>> {
    return this.http
      .get<PaginatedResponse>(
        `${environment.apiUrl}/surchargeType/${surchargeTypeId}/rates`,
        { params: params },
      )
      .pipe(
        map(
          (list) =>
            new PaginationList<SurchargeTypeRate>(
              list.items.map(SurchargeTypeRateMapper.map),
              list.total,
            ),
        ),
      );
  }
}
